module.exports = __webpack_public_path__ + "media/cortina/guia-der-alacolumna-3887a1a1.png";